import { z } from 'zod';

export const FormSchema = z.object({
  ma_bp: z.string().min(1, 'Mã bộ phận là bắt buộc'),
  ten_bp: z.string().min(1, 'Tên bộ phận là bắt buộc'),
  ten_bp2: z.string().optional().nullable(),
  ma_bp_phi: z.string().optional().nullable(),
  ghi_chu: z.string().optional().nullable(),
  status: z.string().min(1, 'Trạng thái là bắt buộc')
});
export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ma_bp: '',
  ten_bp: '',
  ten_bp2: null,
  ma_bp_phi: null,
  ghi_chu: null,
  status: '1'
};
